import styled from 'styled-components';
import {ContentStyled} from '../../styles/components/content.style';

export const TermsPageContentWrapperStyled = styled(ContentStyled)`
  background: ${props => props.theme.termsPage.backgroundColor};
  a {
    color: ${props => props.theme.termsPage.linkColor};
  }
`;

export const H1 = styled.h1`
  line-height: ${props => props.theme.h1.lineHeight};
`;



// WEBPACK FOOTER //
// ./containers/TermsPage/TermsPage.style.js